import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";

const typeLabel: Record<WorkItem["type"], string> = {
  new: "新番",
  movie: "剧场版",
  ova: "OVA",
  classic: "经典",
};

const typeColor: Record<WorkItem["type"], string> = {
  new: "bg-primary-500 text-background-50",
  movie: "bg-accent-500 text-background-50",
  ova: "bg-secondary-500 text-background-50",
  classic: "bg-foreground-200 text-foreground-800",
};

export default function WorkCard({ work }: { work: WorkItem }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-300/60 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-500/60"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden">
        <img
          src={work.image}
          alt={`${work.title} 动漫海报`}
          title={`${work.title} - ${work.category}番剧推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2.5 py-1 text-xs font-bold ${typeColor[work.type]}`}
        >
          {typeLabel[work.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-background-950/80 px-2 py-1 text-xs font-bold text-secondary-400">
          <i className="ri-star-fill" />
          {work.score.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-1 bg-gradient-to-t from-background-950/95 to-transparent p-3 pt-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <p className="line-clamp-2 text-xs leading-relaxed text-foreground-800">{work.description}</p>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-400">
          {work.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{work.category}番</span>
          <span className="h-1 w-1 rounded-full bg-foreground-500/60" />
          <span>{work.year}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 pt-1">
          {work.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}